/**
 * Pre-set colour palette for menswear products. Slug is what's stored on
 * items.colours[] (matches the existing `colours` column shape — array of
 * lowercase strings). Hex is used for swatches in admin and on browse.
 */
export interface ColourOption {
  slug: string;
  name: string;
  hex: string;
}

export const COLOURS: ColourOption[] = [
  { slug: 'black', name: 'Black', hex: '#0e0e0e' },
  { slug: 'charcoal', name: 'Charcoal', hex: '#3a3a3a' },
  { slug: 'grey', name: 'Grey', hex: '#9a9a9a' },
  { slug: 'silver', name: 'Silver', hex: '#c8c8c8' },
  { slug: 'white', name: 'White', hex: '#ffffff' },
  { slug: 'cream', name: 'Cream', hex: '#f4ead6' },
  { slug: 'beige', name: 'Beige', hex: '#d8c8a8' },
  { slug: 'tan', name: 'Tan', hex: '#b89870' },
  { slug: 'brown', name: 'Brown', hex: '#6e4a2a' },
  { slug: 'chocolate', name: 'Chocolate', hex: '#3e2418' },
  { slug: 'navy', name: 'Navy', hex: '#1a2a4a' },
  { slug: 'blue', name: 'Blue', hex: '#3a6cc8' },
  { slug: 'sky-blue', name: 'Sky Blue', hex: '#9ec8e8' },
  { slug: 'teal', name: 'Teal', hex: '#2a7a78' },
  { slug: 'green', name: 'Green', hex: '#3a8a55' },
  { slug: 'forest', name: 'Forest', hex: '#264a30' },
  { slug: 'olive', name: 'Olive', hex: '#6e6a3a' },
  { slug: 'khaki', name: 'Khaki', hex: '#a89860' },
  { slug: 'mustard', name: 'Mustard', hex: '#c89a30' },
  { slug: 'yellow', name: 'Yellow', hex: '#e8c84a' },
  { slug: 'orange', name: 'Orange', hex: '#d8742a' },
  { slug: 'red', name: 'Red', hex: '#b23a2e' },
  { slug: 'burgundy', name: 'Burgundy', hex: '#5a1a1a' },
  { slug: 'pink', name: 'Pink', hex: '#e89aa8' },
  { slug: 'purple', name: 'Purple', hex: '#5a3a7a' },
  { slug: 'lilac', name: 'Lilac', hex: '#c8b0d8' },
  { slug: 'multicolour', name: 'Multicolour', hex: 'conic-gradient(red,orange,yellow,green,blue,purple,red)' },
  { slug: 'patterned', name: 'Patterned', hex: 'repeating-linear-gradient(45deg,#0e0e0e 0 4px,#fff 4px 8px)' }
];

export function colourByName(slug: string): ColourOption | undefined {
  return COLOURS.find((c) => c.slug === slug || c.name.toLowerCase() === slug.toLowerCase());
}
